import NewBaseTable from './NewBaseTable';

export default NewBaseTable;
